import {cssRaw, cssRule} from 'typestyle';

export const colors = {
  'blue_00': '#1952C3',
  'blue_10': '#6796ED',

  'green_00': '#5BC53A',

  'organge_00': '#EE722E',

  'red_00': '#FF4145',

  'yellow_00': '#F8CE46',

  'grey_00': '#333746',
  'grey_10': '#515565',
  'grey_20': '#8995AD',
  'grey_30': '#E1E4EA',
  'grey_40': '#F0F1F5',

  dark: '#20252f',
  darker: '#171b21',
  darkest: '#121317',

  hooplaGray: "rgba(174,177,185,0.13)",
  hooplaShadowColor: "rgba(0,0,0,0.04)",
  hooplaTextColor: "rgb(22,23,26)",
  hooplaTextColor120: "rgb(89,89,89)",
  hooplaTextColorTinted: "rgb(20,57,128)",
  hooplaWhite: "rgb(255,255,255)",
  hooplaBackground: "rgb(255,255,255)",
  hooplaBackgroundDarker: "rgb(241,245,249)",
  hooplaBlue: "rgb(99,148,241)",
  hooplaDarkBlue: "rgb(20,58,122)",
  hooplaPurple: "rgb(222,238,247)",
  hooplaOlive: "rgb(201,208,171)",
  hooplaBeige: "rgb(233,213,172)",
  hooplaOrange: "rgb(245,195,153)",
  hooplaBorderColor: "rgb(235,235,236)",
  hooplaBackgroundLightGray: "rgb(250,250,250)",
}

export const queries = {
  small:  { minWidth: '40rem' },
  medium: { minWidth: '50rem' },
  large:  { minWidth: '65rem' },
}

export const injectGlobals = () => {
  cssRule('#root', {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  })

  cssRule("*", {
    boxSizing: "border-box",
    fontFamily: "Inter, sans-serif",
    $nest: {
      "@supports (font-variation-settings: normal)": {
        fontFamily: '"Inter V", sans-serif',
      },
    },
  });

  cssRule("input", {
    fontFamily: "Inter, sans-serif",
    $nest: {
      "@supports (font-variation-settings: normal)": {
        fontFamily: '"Inter V", sans-serif',
      },
    },
  });

  cssRule("html, body", {
    height: "100%",
    backgroundColor: colors.hooplaWhite,
    color: colors.hooplaTextColor,
    lineHeight: "1.4rem",
  });

  cssRaw("* { -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; }");
}
